export default function formatCurrency(total, grouping, lang = 'en') {
	return new Intl.NumberFormat(lang, { maximumFractionDigits: 2, useGrouping: !!grouping }).format(total);
}
